import React from 'react';

type PageSectionTitleProps = {
  mode?: 'parallax';
  text: string;
};

// Rendered as an h2, not an h1. Pages already emit their single h1 from HeaderSection, and a page
// carrying several h1s gives search and answer engines no section boundaries to chunk on. The
// explicit sizes reproduce the global h1 rule so nothing moves visually.
const TITLE_SIZE_CLASSNAME = 'text-section-title';

const PageSectionTitle: React.FC<PageSectionTitleProps> = (props) => {
  const { text, mode } = props;
  if (mode === 'parallax') {
    return <h2 className={`${TITLE_SIZE_CLASSNAME} max-w-4xl leading-none mt-[20px] md:mt-[100px] mb-[40px] md:mb-[200px]`}>{text}</h2>;
  }
  return (
    <div className="flex justify-center md:text-center">
      <h2 className={`${TITLE_SIZE_CLASSNAME} max-w-4xl leading-none mb-[40px] md:mb-[100px]`}>{text}</h2>
    </div>
  );
};
PageSectionTitle.displayName = 'PageSectionTitle';
export default PageSectionTitle;
